import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'DashboardView',
  setup() {
    const totalUsers = ref(1234)
    const activeToday = ref(123)
    const newThisMonth = ref(456)

    return {
      totalUsers,
      activeToday,
      newThisMonth
    }
  }
}) 